import { MealSourceDto, NutriSearchFilterDto, TextSearchDto } from "../api";

export type NutriSearchFilter = NutriSearchFilterDto;

export type TextSearch = TextSearchDto;

export type SearchResult<T> = {
  count: number;
  searchResults: T[];
};

export type MealIndicator = MealSourceDto["indicator"];

export const mealIndicatorOptions: {
  label: string;
  value: MealIndicator | undefined;
}[] = [
  { label: "Alle", value: undefined },
  { label: "Gericht", value: "DISH" },
  { label: "Lebensmittel", value: "FOOD" },
  { label: "Produkte", value: "PURCHASE" },
];

export const mealIndicatorLabels: Record<MealIndicator, string> = {
  DISH: "Gericht",
  FOOD: "Lebensmittel",
  PURCHASE: "Produkte",
  MEAL: "Mahlzeit",
  MEALS_FOR_DAY: "Tagesmahlzeit",
};

export const emptyNutriSearchFilter: NutriSearchFilter = {
  minFat: 0,
  maxFat: undefined,
  minCarbs: 0,
  maxCarbs: undefined,
  minProtein: 0,
  maxProtein: undefined,
  minKcal: 0,
  maxKcal: undefined,
};

export function isNutriFilterActive(filter: NutriSearchFilter): boolean {
  return (
    filter.minFat > 0 ||
    filter.minCarbs > 0 ||
    filter.minProtein > 0 ||
    filter.minKcal > 0 ||
    filter.maxFat != null ||
    filter.maxCarbs != null ||
    filter.maxProtein != null ||
    filter.maxKcal != null
  );
}

export function formatNutriFilterRange(
  min: number,
  max: number | undefined,
): string | undefined {
  const hasMin = min > 0;
  const hasMax = max != null;
  if (hasMin && hasMax) return `${min}–${max}`;
  if (hasMax) return `≤ ${max}`;
  if (hasMin) return `≥ ${min}`;
  return undefined;
}
